import CodeMirror from 'codemirror';
import _ from 'lodash';
import {
    highlightedFunctionNames,
    highlightedObjectNamesWithDot,
    highlightedObjectNames
} from '../../const/keywords';

import { lodashFunctions } from '../../const/lodashKeywords';

import { stringFunctions } from '../../const/stringKeywords';

var WORD = /[\.\_\w$]+/, RANGE = 500;

CodeMirror.registerHelper("hint", "anyword", function (editor, options) {
    var word = options && options.word || WORD;
    var range = options && options.range || RANGE;
    var cur = editor.getCursor(), curLine = editor.getLine(cur.line);
    var end = cur.ch, start = end;
    while (start && word.test(curLine.charAt(start - 1))) --start;
    var curWord = start != end && curLine.slice(start, end);
    var curToken = editor.getTokenAt(cur);
    var list = options && options.list || [], seen = {};
    list = _.uniq([
        ...highlightedFunctionNames,
        ...highlightedObjectNamesWithDot,
        ...highlightedObjectNames,
    ])
        .map(word => {
            return {
                text: word,
                type: 'alan'
            };
        });

    list = [...list, ...lodashFunctions.map(word => {
        return {
            text: word,
            type: 'lodash'
        };
    })];

    list = [...list, ...stringFunctions.map(word => {
        return {
            text: word,
            type: 'string'
        };
    })]

    if (!curWord) {
        if (curLine.substr(curToken.start - 1, curToken.end - curToken.start + 1) === '_.') {
            curWord = '_.';
        }
    }

    if (curWord) {
        list = list.filter(w => w.text.indexOf(curWord) === 0);
    }

    var re = new RegExp(word.source, "g");
    for (var dir = -1; dir <= 1; dir += 2) {
        var line = cur.line, endLine = Math.min(Math.max(line + dir * range, editor.firstLine()), editor.lastLine()) + dir;
        for (; line != endLine; line += dir) {
            var text = editor.getLine(line), m;
            while (m = re.exec(text)) {
                if (line == cur.line && m[0] === curWord) continue;
                if ((!curWord || m[0].lastIndexOf(curWord, 0) == 0) && !Object.prototype.hasOwnProperty.call(seen, m[0])) {
                    seen[m[0]] = true;
                    if (!_.find(list, { text: m[0] })) {
                        list.push({ text: m[0], type: 'any' });
                    }
                }
            }
        }
    }

    list = list.filter(el => el.text.indexOf('...') === -1);

    return {
        list: list, from: CodeMirror.Pos(cur.line, start), to: CodeMirror.Pos(cur.line, end)
    };
});
